import { render, staticRenderFns } from "./CreatePubgTournament.vue?vue&type=template&id=598c8dc0&scoped=true&lang=pug"
import script from "./CreatePubgTournament.vue?vue&type=script&lang=js"
export * from "./CreatePubgTournament.vue?vue&type=script&lang=js"
import style0 from "./CreatePubgTournament.vue?vue&type=style&index=0&id=598c8dc0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598c8dc0",
  null
  
)

export default component.exports